import React from "react";

// Dartboard / target logo recreated as inline SVG (matches reference header).
export default function TargetLogo({ size = 52 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label="Bhutan Morning Teer target logo"
      data-testid="target-logo"
    >
      <circle cx="50" cy="50" r="48" fill="#ffffff" stroke="#d11f2a" strokeWidth="3" />
      <circle cx="50" cy="50" r="38" fill="#e23b3b" />
      <circle cx="50" cy="50" r="29" fill="#ffffff" />
      <circle cx="50" cy="50" r="20" fill="#e23b3b" />
      <circle cx="50" cy="50" r="11" fill="#ffffff" />
      <circle cx="50" cy="50" r="5" fill="#e23b3b" />
      {/* dart */}
      <line x1="58" y1="18" x2="46" y2="46" stroke="#1a5fb4" strokeWidth="4" strokeLinecap="round" />
      <polygon points="44,50 48,42 52,48" fill="#1a5fb4" />
      <path d="M58 18 l10 -6 -3 8 6 3 -9 3z" fill="#f6c445" stroke="#c99a1f" strokeWidth="1" />
    </svg>
  );
}
